import * as React from 'react'
import styled from 'styled-components'
import ReactModal from 'react-modal'

import SearchMall from '../SearchMall/SearchMall'

import * as ProfileApiServices from '../../../services/api/requests/Profile'
import media from '../../../services/generateMediaQueries'

import getDeviceLocation from '../../../services/location/getDeviceLocation'
import DialogModal from '../../ui/DialogModal/DialogModal'

const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background: rgb(255, 255, 255);
  outline: none;
  width: 100%;
  height: 100%;
  max-width: 375px;
  opacity: 0;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('xsmall')`
    border-radius: 0;
    max-width: unset;
  `}
`

const SearchContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const overlay = {
  zIndex: 999,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

class SearchMallModal extends React.Component {
  state = {
    keyword: '',
    mallId: '',
    results: [],
    recentSearches: [],
    popularPlaces: [],
    isUserSearching: false,
    loading: false,
    showSearchMall: false,
    selectedMall: {},
    favoriteMalls: [],
    favoriteLoadingStatus: null,
    position: null,
    positionLoading: null,
    loginPromptModalVisible: false,
    maxFavoriteModalVisible: false,
  }

  componentDidMount() {
    this.setState({
      positionLoading: true,
    })
    getDeviceLocation().then(
      location => {
        this.setState({
          position: {
            latitude: location.coords.latitude,
            longitude: location.coords.longitude,
          },
          positionLoading: false,
        })
      },
      () => {
        this.setState({
          positionLoading: false,
        })
      },
    )
  }

  handleSelectMall = id => {
    const {
      malls,
      onChangeMall,
      setSelectedMallSlug,
      match,
      baseUrl,
      push,
      // efood,
    } = this.props

    const selectedMall = malls.filter(mall => mall.id === id)

    async function goToEconcierge() {
      let extra =
        '/' + (selectedMall[0].slugName || selectedMall[0].mallSlugName)
      if (
        (baseUrl === '/econcierge' || baseUrl === '/zing-eats') &&
        match.params.viewType &&
        selectedMall.length
      ) {
        extra += '/view-all/' + match.params.viewType
      }
      await push(`${baseUrl + extra}`)
    }

    if (selectedMall.length > 0 && setSelectedMallSlug) {
      onChangeMall(selectedMall[0].slugName || selectedMall[0].mallSlugName)
      setSelectedMallSlug(
        selectedMall[0].slugName || selectedMall[0].mallSlugName,
      )
      goToEconcierge()
    }
  }

  handleSearchMallClose = () => {
    const { onClose } = this.props

    if (onClose) {
      onClose(false)
    }
  }

  onFavoriteClicked = async id => {
    const { accessToken, favoriteMalls, isEconcierge } = this.props

    if (
      accessToken !== null &&
      (isEconcierge === null || isEconcierge === false)
    ) {
      try {
        if (
          favoriteMalls.length === 3 &&
          !favoriteMalls.map(m => m.id).includes(id)
        ) {
          this.setState({
            maxFavoriteModalVisible: true,
          })
          return favoriteMalls
        }

        const favoriteResponse = await ProfileApiServices.postFavoriteMall(
          id,
          accessToken,
        )

        this.setState({
          favoriteMalls: favoriteResponse.data,
        })

        return favoriteResponse.data
      } catch (error) {
        const { data = {} } = error.response || {}
        const { message = 'Network Error' } = data || {}
        throw new Error(message)
      }
    }

    this.setState({
      loginPromptModalVisible: true,
    })

    return []
  }

  onLoginConfirmOk = () => {
    const { push } = this.props

    this.setState({
      loginPromptModalVisible: false,
    })

    push('/login')
  }

  onRegisterConfirmOk = () => {
    const { push } = this.props

    this.setState({
      loginPromptModalVisible: false,
    })

    push('/register')
  }

  toggleDialogModal = visible => {
    this.setState({
      maxFavoriteModalVisible: visible,
    })
  }

  render() {
    const {
      modalState,
      malls,
      selectedMall,
      accessToken,
      favoriteMalls,
      deviceLocation,
      setFavoriteMalls,
      displayClose,
      efood,
    } = this.props
    const { loginPromptModalVisible, maxFavoriteModalVisible } = this.state

    return (
      <>
        <StyledReactModal
          isOpen={modalState}
          style={{ overlay, content }}
          onRequestClose={this.handleSearchMallClose}
          closeTimeoutMS={150}
          bodyOpenClassName="sticky-modal-open"
          htmlOpenClassName="sticky-modal-open"
        >
          <SearchContentContainer>
            <SearchMall
              accessToken={accessToken}
              show={modalState}
              malls={malls}
              favoriteMalls={favoriteMalls}
              onFavoriteClicked={this.onFavoriteClicked}
              onSelectMall={this.handleSelectMall}
              onPageClose={this.handleSearchMallClose}
              displayClose={selectedMall || displayClose}
              displaySelectAll={false}
              deviceLocation={deviceLocation}
              setFavoriteMalls={setFavoriteMalls}
              efood={efood}
            />
          </SearchContentContainer>
        </StyledReactModal>
        <DialogModal
          modalState={loginPromptModalVisible}
          title="Zing account required"
          description="Register or login to use this feature."
          align="center"
          onCancel={this.onRegisterConfirmOk}
          cancelText="Register Now"
          onOk={this.onLoginConfirmOk}
          onClose={() => {
            this.setState({
              loginPromptModalVisible: false,
            })
          }}
          okText="Log In"
          showCloseButton
        />
        <DialogModal
          modalState={!!maxFavoriteModalVisible}
          title="Favorite Malls"
          description="You can only select up to 3 favorite malls"
          okText="Okay"
          onOk={() => this.toggleDialogModal(false)}
          hasCancel={false}
          align="center"
        />
      </>
    )
  }
}
SearchMallModal.defaultProps = {}

SearchMallModal.propTypes = {
  // TODO: specify prop types
}

export default SearchMallModal
